import AdminLayout from "@/views/admin/AdminLayout.vue"
import BusinessList from "@/views/admin/mybizes/BusinessList.vue"
import BusinessInfo from "@/views/admin/mybizes/BusinessInfo.vue"

const routes = [
  {
    path: "/:lang/mybizes",
    component: AdminLayout,

    children: [
      {
        path: "",
        name: "BusinessList",
        component: BusinessList,
        meta: {
          title: "MyBizes.__MyBizes",
          requireAuth: true,
          auth: 0
        },
        props: route => ({
          ...route.params
        })
      },
      {
        path: "new",
        name: "BusinessNew",
        meta: {
          title: "MyBizes.__AddBiz",
          requireAuth: true,
          auth: 0
        },
        component: BusinessInfo
      },
      {
        path: "edit/:id",
        name: "BusinessEdit",
        meta: {
          title: "MyBizes.__EditBiz",
          requireAuth: true,
          auth: 0
        },
        component: BusinessInfo
      }
    ]
  }
]

export default routes
